import React, { lazy, Suspense } from 'react';
import { Provider } from 'react-redux';
import {store} from '../../app/interviewStore';
import InvalidInterviewLink from 'Modal/Error/InvalidInterviewLink';
import CompFallbackLoader from 'Modules/Interview/Common/CompFallbackLoader/CompFallbackLoader';
const LazyInterview = lazy(() => import('./Interview'));
const LazyCodeCompiler = lazy(() => import('./CodeCompiler/CodeCompiler'));
const LazyProctor = lazy(() => import('../Proctor/Proctor/Proctor'));
const LazyCandidateList = lazy(() => import('Modules/Proctor/Proctor/CandidateList'));
const LazyReferals = lazy(() => import('Modules/Referals/Referals'));
const LazySharePage = lazy(() => import('Modules/VideoShare/Share'));
const LazyTestimonialVideoShare = lazy(() => import('Modules/TestimonialVideoShare/TestimonialVideoShare'));

const Interview = props => (
  <Suspense fallback={<CompFallbackLoader />}>
    <Provider store={store}>
      <LazyInterview {...props} />
    </Provider>
  </Suspense>
);

const CodeCompiler = props => (
  <Suspense fallback={<CompFallbackLoader />}>
    <Provider store={store}>
      <LazyCodeCompiler {...props} />
    </Provider>
  </Suspense>
);

const Proctor = props => (
  <Suspense fallback={<CompFallbackLoader />}>
      <LazyProctor {...props} />
  </Suspense>
);

const CandidateList = props => (
  <Suspense fallback={<CompFallbackLoader />}>
      <LazyCandidateList {...props} />
  </Suspense>
);

const Referals = props => (
  <Suspense fallback={<CompFallbackLoader />}>
      <LazyReferals {...props} />
  </Suspense>
);

const SharePage = props => (
  <Suspense fallback={<CompFallbackLoader />}>
      <LazySharePage {...props} />
  </Suspense>
);

const TestimonialVideoShare = props => (
  <Suspense fallback={<CompFallbackLoader />}>
      <LazyTestimonialVideoShare {...props} />
  </Suspense>
);  

Interview.routeProps = [
  {
    path: '/video-interview/:jobid/:jobseekerid/:id',
    exact: true,
    element: <Interview internal ="0"/>
  }, 
  {
    // Path for mock interview, where we are getting catcher id and Kit id.
    // We are setting internal = 2 for Mock Interview.
    path: '/kit-preview/:catcher_id/:kit_id/',
    exact: true,
    element: <Interview internal ="2"/>
  }, 
  {
    path: '/compiler/:catcher_id/:kit_id/',
    exact: true,
    element: <CodeCompiler internal ="3"/>
  }, 
  {
    path: '/compile-question/:catcher_id/:kit_id/:ques_id',
    exact: true,
    element: <CodeCompiler internal ="4"/>
  }, 
  {
    path: '/compile-evaluated-question/:catcher_id/:kit_id/:ques_id/:invitation_id/:ats_interview',
    exact: true,
    element: <CodeCompiler internal ="5"/>
  }, 
  {
    path: '/video-interview/:jobid/:jobseekerid/:id/:reInviteId',
    exact: true,
    element: <Interview internal ="0"/>
  },
  {
    path:'/video-interview/:id/:jobseekerid',
    exact :true,
    element:<Interview internal='1' />
  },
  {
    path:'/proctoring/:id/:themeValue/:trans',
    exact :true,
    element:<Proctor internal='0' />
  },
  {
    path:'/proctoring/candidates-list',
    exact:true,
    element:<CandidateList />
  },
  {
    path:'/*',
    exact:false,
    element:<InvalidInterviewLink />
  },
  {
    path:'/reference-screening/:id',
    exact:true,
    element:<Referals/>
  },
  {
    path:'/share-video/:id',
    exact:true,
    element:<SharePage/>
  },
  {
    path:'/testimonial/:id',
    exact:true,
    element:<TestimonialVideoShare/>
  },
];

export default Interview;
